import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHandTypes, ShowerHeadTypes} from "../../constants";

export default class ShowerHose extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_hose';
    this.partName = 'Shower Hose';
    this.translateId = "visualizer.bathroom.shower.shower_hose";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    const showerParent = this.getParent().getParent();
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_arm);
    showerParent.setShowerHandType(ShowerHandTypes.hand_shower_holder);
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm || showerParent.shower_hand_type !== ShowerHandTypes.hand_shower_holder
  }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    let conditions = super.getArrayOfConditions(); //roomLayout
    if (showerParent.handShowerHolder && showerParent.handShowerHolder.activeFeature) {
      conditions.push({
        propName: "MountPosition",
        propValue: showerParent.handShowerHolder.activeFeature.metaData["MountPosition"]
          ? showerParent.handShowerHolder.activeFeature.metaData["MountPosition"]
          : ["2"]
      })
    }
    return conditions
  }

}
